import styled from 'styled-components'

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.colors.grey4};

  &:hover {
    background-color: #d6d6da;
  }
  &:active {
    background-color: #c2c2c8;
  }
`

export const MessageBullet = styled.span`
  position: absolute;
  top: -7px;
  right: -4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid white;
  background-color: ${({ theme }) => theme.colors.danger.normal};
  font-family: 'Arial';

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: white;
  border: 1px solid white;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    top: 0px;
    right: 1px;
  }
`
